import React, { useState, useEffect, useRef } from 'react';
import { Spin } from "antd";
import { WithOverrides } from '../../components';
import { ContentTypes, SelectedContent } from './components';
import style from './content.module.scss';
import { useAppAndBranchId, usePermissions } from '../../hooks';
import { Content } from './types';
import { api } from './api';
import NoData from '../../../../NoData';
import { ReactComponent as WarningIcon } from '../../../../../../assets/svg/warningIcon.svg';

export function SoloChatContent() {
  const scrollRef = useRef<any | null>(null);
  let [loading, setLoading] = useState<boolean>(true)
  let noOfMaxContent = Math.ceil(Number((window.innerHeight - 196) / 47));
  let [hasMore, setHasMore] = useState<boolean>(true);
  const [appId, branchId] = useAppAndBranchId();
  let [dataSource, setDataSource] = useState<any>([]);
  const [contentType, setContentType] = useState<Content['contentType']>('' as any);
  let [createdAt, setCreatedAt] = useState<string>('')
  let [lastContentId, setLastContentId] = useState<string | null>(null); 

  useEffect(() => {
    fetchData('INIT')
  }, [])

  useEffect(() => {
    setHasMore(true);
    setLoading(true);
    setDataSource([]);
    fetchData('INIT');
  }, [contentType, branchId])

  function refetchDataSource() {
    if (scrollRef?.current) {
      scrollRef.current.scrollTop = 0;
    }
    setHasMore(true);
    setLoading(true);
    fetchData("INIT")
  }

  async function loadMore() {
    await fetchData();
  }

  async function fetchData(proFrom?: string) {
    if (!contentType) return;

    try {
      const startTime = proFrom === "INIT" ? null : createdAt;
      const lastContentIdParam = proFrom === "INIT"? null : lastContentId;
      const sendLimit = proFrom === "INIT" ? noOfMaxContent : 15;
      const contents: any = await api.getChatContents(appId, branchId, contentType, {limit: sendLimit, startTime, lastContentId: lastContentIdParam });
      if (contents && contents.length > 0) {
        if (proFrom !== "INIT") {
          setHasMore(true);
          setDataSource((prevState: any) => {
            return [...prevState, ...contents]
          });
          setCreatedAt(contents[contents.length - 1]?.createdAt)
          setLastContentId(contents[contents.length - 1]?.id);
        } else {
          setDataSource(contents);
          setCreatedAt(contents[contents.length - 1]?.createdAt)
          setLastContentId(contents[contents.length - 1]?.id);
        }
      } else {
        setHasMore(false)
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  }

  const selectedContent =
    dataSource?.filter((el: any) => el.contentType === contentType) ?? [];

  const canView = usePermissions("content.View")

  return canView ? (
    <WithOverrides>
      <div className={style.content}>
        <ContentTypes
          setContentType={setContentType}
          contentType={contentType}
        />
        {loading ?
          <div className={style.content_spinner}>
            <Spin size="large" style={{ color: '#15808C' }} />
          </div>
          :
          <SelectedContent
            scrollRef={scrollRef}
            hasMore={hasMore}
            refetchContent={refetchDataSource}
            contentType={contentType}
            contents={selectedContent}
            loadMore={loadMore}
          />
        }

      </div>
    </WithOverrides>
  ) : (
      <div className="viewWrapper">
        <NoData
          svg={WarningIcon}
          header="Not Authorized"
          content="Please request owner of this organization to provide access"
          noButton={true}
        />
      </div>
    );
}
